export default __webpack_public_path__ + "static/media/close-square.3912e3ea.svg";